const Loader = ({ text, className }) => (
  <div className={`w-100 d-flex flex-column align-items-center text-primary ${className}`}>
    <div className="spinner-border" />
    {text && <div className="mt-4">{text}</div>}
  </div>
);

export default Loader;
